import script from "./WomuMain.vue?vue&type=script&setup=true&name=WomuMain&lang=js"
export * from "./WomuMain.vue?vue&type=script&setup=true&name=WomuMain&lang=js"

const __exports__ = script;

export default __exports__